import { Router } from '@angular/router';
import { WalletService } from './../wallet.service';
import Swal  from 'sweetalert2';
import { Component, NgZone, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fund-wallet',
  templateUrl: './fund-wallet.component.html',
  styleUrls: ['./fund-wallet.component.css'],
})
export class FundWalletComponent implements OnInit {
  @ViewChild('fundwalletModal')modal!: ElementRef;
  payStackKey = environment.paystackKey;
  accountID = localStorage.getItem("accountID")
  paystack: any;
  amount = '';
  alermsg: any;
  paymentResponse = { status: '', message: ''}
  $:any;

  constructor(private ngZone: NgZone,
    private internalService: WalletService, private route: Router) {}

  FundAccount = new FormGroup({
    amount: new FormControl(' ', Validators.required),
  });

  fund(){
    this.paystackInit();
  }

  paystackInit(){
    const winPaystackPop = (window as any).PaystackPop;
    const metadata = {
      accountID: localStorage.getItem("accountID"),
      status: localStorage.getItem("status"),
      type: "Topup"
    };
    const amount = parseInt(this.FundAccount.getRawValue().amount) *100; 

    if(winPaystackPop){
      const handler = winPaystackPop.setup({
        key: this.payStackKey,
        email: `${localStorage.getItem("email")}`,
        amount,
        metadata: {...metadata},
        currency: 'NGN',
        ref: `THR${Math.ceil(Math.random() * 10e10)}`,
        callback: (response:any) => this.ngZone.run(() => {
            this.confirmPayment(response)
        })
      });
      handler.openIframe()
    } else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'An error occured, reload page and try again',
        showConfirmButton: false,
        timer: 3500
      })
    }
  }

  confirmPayment(response: any){
      const payload = {referenceNumber: response.trxref, userAccountNumber: this.accountID};
      this.internalService.confirmPayment(payload).subscribe((res:any) =>{
        this.alermsg = !this.alermsg;
        this.paymentResponse = {status: response.status, message: res.message}
        
        if(res.status == 200){
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Funding Successful',
            showConfirmButton: false,
            timer: 3500
          })
          this.FundAccount.reset();
          this.amount = '';
          this.reloadComponent();
          this.closeModal();
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title:`${res.message}`,
            showConfirmButton: false,
            timer: 3500
          })
          this.reloadComponent();
        }
      })
      
  }

  closeModal(){
    this.modal.nativeElement.classList.remove('show');
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = '';
    console.log("Fund wallet closed");
    
  }

  reloadComponent() {
    this.route.navigateByUrl('/myboard/wallet', { skipLocationChange: true }).then(() => {
      this.route.navigate(['/myboard/wallet']);
    });
    
    
  }


  

  paymentCancel() {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'You Aborted Funding Process',
      showConfirmButton: false,
      timer: 3500
    })
  }

  ngOnInit(): void {
    this.alermsg = false;
  }
}
